import React, { useMemo } from 'react';
import { sortBreakdownByMetric } from '../../../utils/gaDashboard';

const BAR_COLORS = [
  'rgb(var(--admin-chart-blue))',
  'rgb(var(--admin-accent))',
  'rgb(var(--admin-chart-green))',
  'rgb(var(--admin-chart-orange))',
  'rgb(var(--admin-chart-purple))',
  'rgb(var(--admin-chart-cyan))',
  'rgb(var(--admin-chart-gray))',
];

export function BreakdownBarRow({
  label,
  value,
  maxValue,
  barColor = 'rgb(var(--admin-chart-blue))',
  subtext,
}) {
  const pct = maxValue > 0 ? Math.max(4, Math.round((value / maxValue) * 100)) : 0;

  return (
    <div className="py-2.5 border-b border-dark-border/40 last:border-b-0">
      <div className="flex justify-between items-start gap-3 text-sm mb-1.5">
        <span
          className="text-dark-text leading-snug break-all min-w-0 flex-1"
          title={label}
        >
          {label}
        </span>
        <span className="text-dark-text font-semibold shrink-0 tabular-nums">
          {value.toLocaleString()}
        </span>
      </div>
      <div className="h-2 rounded-full bg-dark-bg overflow-hidden">
        <div
          className="h-full rounded-full transition-all"
          style={{ width: `${pct}%`, backgroundColor: barColor }}
        />
      </div>
      {subtext && (
        <p className="text-xs text-dark-text-secondary mt-1">{subtext}</p>
      )}
    </div>
  );
}

export default function GaBreakdownBarList({
  items,
  metricKey = 'activeUsers',
  topN = 7,
  showSessionsEvents = false,
  t,
}) {
  const rows = useMemo(
    () =>
      sortBreakdownByMetric(items, metricKey, topN).filter(
        (row) => row.dimension && String(row.dimension).trim() !== '' && (row[metricKey] || 0) > 0,
      ),
    [items, metricKey, topN],
  );

  const maxValue = useMemo(
    () => rows.reduce((m, row) => Math.max(m, row[metricKey] || 0), 0),
    [rows, metricKey],
  );

  return (
    <div className="flex-1 overflow-y-auto">
      {rows.map((row, index) => {
        let subtext;
        if (showSessionsEvents && t && (row.sessions > 0 || row.eventCount > 0)) {
          subtext = `${t('dashboard.ga.breakdown.sessions')}: ${row.sessions} · ${t('dashboard.ga.breakdown.events')}: ${row.eventCount}`;
        }
        return (
          <BreakdownBarRow
            key={row.dimension}
            label={row.dimension}
            value={row[metricKey] || 0}
            maxValue={maxValue}
            barColor={BAR_COLORS[index % BAR_COLORS.length]}
            subtext={subtext}
          />
        );
      })}
    </div>
  );
}
